module.exports = __webpack_public_path__ + "img/pointO.a07a5254.svg";